import React from 'react';


import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { FroumGroupsValuesComponent } from './community-forum-info.component';
import { UploadMedia } from '../../../../../common/components/common/upload-media';
import CommunityBasicInfoComponent from './community-basic-info.component';
import SubscriptionsComponent from './subscriptions.component';




export const CommunityComponent = ({ selectedForumGroupsValues, id, onFormItemChange, selectedPrograms, columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit, changeLogoImage, changeCoverImage, libraryData, communityStatus, selectedCommunity }: any) => {
  const handleInnerMediaFormChange: any = ({ field, value }: any) => {
    onFormItemChange({
      value: value.MediaFiles,
      field: 'MediaFiles',
      idx: '', //not used
    });
  };
  const tabItems = [
    {
      id: 1,
      title: 'Basic-Info',
      component: (
        <CommunityBasicInfoComponent
          onInnerBasicFormChange={onInnerBasicFormChange}
          selectedCommunity={selectedCommunity}
          libraryData={libraryData}
          changeLogoImage={changeLogoImage}
          changeCoverImage={changeCoverImage}
        />
      ),
      isVisible: true,
    },

     {
      id: 2,
      title: 'Subscriptions',
      component: (
        <SubscriptionsComponent
          libraryData={libraryData}
          id={id}
        />
      ),
      isVisible: true,
    },

    {
      id: 3,
      title: 'Forum Groups',
      component:
        <FroumGroupsValuesComponent
          handleDelete={handleDelete}
          additionButtons={additionButtons}
          handleEdit={handleEdit}
          columnDefs={columnDefs}
          onInnerBasicFormChange={onInnerBasicFormChange}
          selectedForumGroupsValues={selectedForumGroupsValues}
        />,
      isVisible: true,
    },

    {
      id: 4,
      title: 'Media',
      component:
        <UploadMedia
          handleInnerFormChange={handleInnerMediaFormChange}
          mediaFilesList={selectedCommunity?.MediaMappings?.MediaFiles}
          ownerTypeId={1007}
          ownerId={id}
          folderName={'oneprogram'}
        />,
      isVisible: true,
    },

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default CommunityComponent;